import { render } from "./CreateSites.vue?vue&type=template&id=2fc0e461&ts=true"
import script from "./CreateSites.vue?vue&type=script&lang=ts"
export * from "./CreateSites.vue?vue&type=script&lang=ts"

import "./CreateSites.vue?vue&type=style&index=0&id=2fc0e461&lang=scss"

import exportComponent from "/github/workspace/merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__